<template lang="html">

  <div class="cover-popup row-center">
    <div class="popup">

      <a @click="$emit('hide')" class="close">✕</a>

      <p>{{$t('popup_borrar_cuenta.titulo')}}</p>

      <div class="contenedor-botones">

        <button class="btn -solid-primary" @click="eraseAccount">{{$t('popup_borrar_cuenta.si')}}</button>
        <button class="btn -skull-primary" @click="$emit('hide')">{{$t('popup_borrar_cuenta.no')}}</button>

      </div>

    </div>
  </div>

</template>

<script lang="js">
  
    import {mapGetters,mapActions} from 'vuex';
  
    export default  {
      name: 'popup-borrar-cuenta',
      data(){
        return {
        }
      },
      computed : {
        ...mapGetters({
          brand:'getBrand',
          style : 'getStyles'
        })
      },
      methods : {
        ...mapActions(['requestEraseAccount']),
        eraseAccount(){
          this.requestEraseAccount().then(r => {
            if(r){
              this.$emit('hide');
            }
          });
        }
      }
    }
  </script>
<style scoped lang="scss">


  
  </style>


// WEBPACK FOOTER //
// src/components/parts/popup-borrar-cuenta.vue